import { useState, useEffect } from 'react'
import {
  Box,
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
} from '@mui/material'

const EditTestCaseConfirmationModal = ({ testCase, editOpen, setEditOpen, pageToggler, setPageToggler }) => {
  const [name, setName] = useState('')
  const [nameError, setNameError] = useState('')

  useEffect(() => {
    if (testCase?.testCaseName) {
      setName(testCase.testCaseName)
    }
  }, [testCase?.testCaseName])

  const handleNameChange = (e) => {
    setName(e.target.value)

    if (nameError) {
      setNameError('')
    }
  }

  const handleCloseEditDialog = () => {
    setEditOpen(false)
  }

  const handleSaveTestCase = () => {
    if (!name.trim()) {
      setNameError('Test Case Name is required.')
      return
    } else {
      setNameError('')
    }

    try {
      console.log('handleSaveTestCase click! ', { id: testCase?.id, testCaseName: name })
      setEditOpen(false)
      setPageToggler(!pageToggler)
    } catch (e) {
      console.log('error')
    }
  }

  return (
    <Dialog
      open={editOpen}
      onClose={handleCloseEditDialog}
    >
      <Box className="editTestCaseModal">
        <DialogTitle className="editTestCaseModalTitle">
          Edit Test Case
        </DialogTitle>
        <DialogContent className="editTestCaseModalContent">
          <DialogContentText className="editTestCaseModalContentText">
            Please edit the name of test case
          </DialogContentText>
          <TextField
            label="Test Case Name *"
            type="text"
            fullWidth
            variant="outlined"
            value={name}
            onChange={handleNameChange}
            error={!!nameError}
            helperText={nameError + ' '}
          />
        </DialogContent>
        <DialogActions className="editTestCaseModalActions">
          <Button className="editTestCaseModalButton" onClick={handleCloseEditDialog} color="secondary" variant="outlined">
            CANCEL
          </Button>
            <Button className="editTestCaseModalButton" onClick={handleSaveTestCase} color="secondary" variant="contained" autoFocus>
              SAVE
            </Button>
        </DialogActions>
      </Box>
    </Dialog>
  )
}

export default EditTestCaseConfirmationModal